<template >
  <div v-if="!updating" class="section-row">
    <div class="vue-form">
      <div class="postnummer-form">
        <div class="vue-form-row has-multiple-elements">
          <vue-input @blur="setPostnummerFieldValue({ fieldId:'postnummerValue', value: $event.target.value })"
            :element="postnummer" />
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./postnummer.js"/>
